import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.benutzer-telefone-aktualisieren-admin';
import * as api from '../../../clients/benutzerverwaltung';

@Injectable()
export class BenutzerverwaltungBenutzerTelefoneAktualisierenAdminEffects {

    BenutzerTelefoneAktualisierenAdmin$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_BENUTZER_TELEFONE_AKTUALISIEREN_ADMIN),
        mergeMap((x: ac.PostBenutzerTelefoneAktualisierenAdminAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postBenutzerTelefoneAktualisierenAdmin(x.benutzerTelefoneAktualisierenRequest).pipe(
                map((result: any) => {
                    return new ac.PostBenutzerTelefoneAktualisierenAdminErfolgreichAction(result, x.benutzerTelefoneAktualisierenRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostBenutzerTelefoneAktualisierenAdminFehlerAction(error, x.benutzerTelefoneAktualisierenRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.BenutzerverwaltungAdminCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.BenutzerverwaltungAdminCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.BenutzerverwaltungAdminCommandService);
        }
        return this.service;
    }
}
